<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report")
          i.fas.fa-chart-line
          span.ml-1 {{ $t("ui.report") }}
      b-breadcrumb-item
        router-link(to="/report/game_result_slots")
          i.fas.fa-th-list
          span.ml-1 {{ $t("ui.game_result_slots") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12
              div.form-row
                .col-xs-10.col-sm-6.col-md-2.col-lg-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-gift
                    DebounceInput(required autofocus type="text" v-model="account_id" :placeholder="$t('ui.account_id')" @keyup.enter.native="submit")
                .col-xs-10.col-sm-6.col-md-2.col-lg-2.mb-1
                  DateRangePicker1(:value="dateRange" @update="getData")
                  //- DateRangePicker(:title="$t('ui.date_range')" :value="dateRange" :placeholder="$t('message.select_date_range')")
                .col-xs-2.col-sm-2.col-md-2.col-lg-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="submit"
                    variant="success"
                    size="sm"
                  )
        div.card-body.p-1
          b-row
            div.col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                @input="changedPage($event)").mb-1
            div.col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              b-table#tblList.table-sm.table-hover(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="list" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                template(v-slot:cell(index)="row")
                  span {{ row.index + 1 }}
                template(v-slot:cell(result_id)="row")
                  b-link(@click="getResultDetail(row.item.result_id)") {{ row.item.result_id }}
                template(v-slot:cell(bet_time)="row")
                  span #[b {{ $moment(row.item.bet_time).format("YYYY-MM-DD HH:mm:ss") }}]
                template(v-slot:cell(currency_code)="row")
                  currency(:currency="row.item.currency_code")
                template(v-slot:cell(turnover)="row")
                  span(:class="$helpers.getNumberClass(row.item.turnover)") #[b {{ row.item.turnover | currency }} ]
                template(v-slot:cell(valid_turnover)="row")
                  span(:class="$helpers.getNumberClass(row.item.valid_turnover)") #[b {{ row.item.valid_turnover | currency }} ]
                template(v-slot:cell(payout)="row")
                  span(:class="$helpers.getNumberClass(row.item.payout)") #[b {{ row.item.payout | currency }} ]
                template(v-slot:cell(winlose)="row")
                  span(:class="$helpers.getNumberClass(row.item.winlose)") #[b {{ row.item.winlose | currency }} ]
                template(v-slot:bottom-row="row" v-if="showTotal")
                  td.text-right(colspan="7")
                    span #[b {{ $t("ui.sub_total") }}]
                    br
                    span #[b {{ $t("ui.grand_total") }} ]
                  td.text-right
                    span(:class="$helpers.getNumberClass(subTotalTurnover)")  #[b {{ subTotalTurnover | currency }}]
                    br
                    span(:class="$helpers.getNumberClass(grandTotalTurnover)")  #[b {{ grandTotalTurnover | currency }} ]
                  td.text-right
                    span(:class="$helpers.getNumberClass(subTotalValidTurnover)")  #[b {{ subTotalValidTurnover | currency }}]
                    br
                    span(:class="$helpers.getNumberClass(grandTotalValidTurnover)")  #[b {{ grandTotalValidTurnover | currency }} ]
                  td.text-right
                    span(:class="$helpers.getNumberClass(subTotalPayout)")  #[b {{ subTotalPayout | currency }}]
                    br
                    span(:class="$helpers.getNumberClass(grandTotalPayout)")  #[b {{ grandTotalPayout | currency }} ]
                  td.text-right
                    span(:class="$helpers.getNumberClass(subTotalWinlose)")  #[b {{ subTotalWinlose | currency }}]
                    br
                    span(:class="$helpers.getNumberClass(grandTotalWinlose)")  #[b {{ grandTotalWinlose | currency }} ]
</template>

<script>
import config from "@/config"
import errorTags from "@/errorTags"
import SubmitButton from "@/library/SubmitButton.vue"
import DebounceInput from "@/library/DebounceInput"
import DateRangePicker from "@/library/DateRangePicker.vue"
import DateRangePicker1 from "@/library/DateRangePicker1.vue"
import currency from "@/components/currency.vue"

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    DateRangePicker1,
    currency
  },
  data() {
    return {
      loading: false,
      account_id: this.$store.getters.accountID,
      showTotal: false,
      filter: null,
      sortBy: "winlose",
      sortDesc: false,
      currentPage: 1,
      totalRows: 0,
      list: [],
      submission: {
        success: false,
        status: errorTags.request.failed
      },
      subTotalTurnover: 0,
      subTotalValidTurnover: 0,
      subTotalPayout: 0,
      subTotalWinlose: 0,
      grandTotalTurnover: 0,
      grandTotalValidTurnover: 0,
      grandTotalPayout: 0,
      grandTotalWinlose: 0
    };
  },
  validations: {},
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "text-center align-middle",
          thStyle: {
            width: "3% !important"
          }
        },
        {
          key: "result_id",
          label: this.$t("ui.result_id"),
          class: "text-left align-middle",
          sortable: true,
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "bet_time",
          label: this.$t("ui.bet_time"),
          class: "text-left align-middle",
          sortable: true,
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "currency_code",
          label: this.$t("ui.currency"),
          class: "text-left align-middle",
          sortable: true,
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "game_provider",
          label: this.$t("ui.game_provider"),
          class: "text-left align-middle",
          sortable: true,
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "game_type",
          label: this.$t("ui.game_type"),
          class: "text-left align-middle",
          sortable: true,
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "game_name",
          label: this.$t("ui.game_name"),
          class: "text-left align-middle",
          sortable: true,
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "turnover",
          label: this.$t("ui.turnover"),
          class: "text-right align-middle",
          sortable: true,
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "valid_turnover",
          label: this.$t("ui.valid_turnover"),
          class: "text-right align-middle",
          sortable: true,
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "payout",
          label: this.$t("ui.payout"),
          class: "text-right align-middle",
          sortable: true,
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "winlose",
          label: this.$t("ui.winlose"),
          class: "text-right align-middle",
          sortable: true,
          thStyle: {
            width: "10%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function() {
    this.submit()
  },
  methods: {
    getResultDetail: function(e) {
      window.open(config.gameResultDetailUrl + e, "info", "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640");
    },
    getData: function(currentValue) {
      this.submit();
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo
      this.submit()
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged: function(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable()
    },
    refreshTable: function() {
      this.$root.$emit("bv::table::refresh", "tblList")
    },
    redirectTo: function(item) {
      // this.$store.dispatch("layout/setDateRange", [new Date(item.working_date),new Date(item.working_date)])
      // this.$store.dispatch("layout/setAccountID", item.account_id)
      // this.$router.push("../report/daily_statement")
    },
    submit: function() {
      if (!this.$v.$invalid) {
        let account_id = this.account_id
        let start_date = this.dateRange.startDate
        let end_date = this.dateRange.endDate
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("report/gameResultSlots", { account_id, start_date, end_date, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            if (this.submission.success == true) {
              // console.log(response)
              this.clear()
              this.showTotal = true
              this.list = response.data
              this.totalRows = response.data.length > 0 ? this.list[0]["totalrows"] : 0

              response.data.forEach(value => {
                this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"])
                this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"])
                this.subTotalPayout = parseFloat(this.subTotalPayout) + parseFloat(value["payout"])
                this.subTotalWinlose = parseFloat(this.subTotalWinlose) + parseFloat(value["winlose"])
              })

              if (response.grandTotal.length > 0) {
                this.grandTotalTurnover = response.grandTotal[0]["turnover"]
                this.grandTotalValidTurnover = response.grandTotal[0]["valid_turnover"]
                this.grandTotalPayout = response.grandTotal[0]["payout"]
                this.grandTotalWinlose = response.grandTotal[0]["winlose"]
              }
            }
          })
          .catch(response => {
            this.loading = false
            this.list = []
            this.totalRows = 0
            this.showTotal = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag);
          });
      }
    },
    clear: function() {
      this.subTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.subTotalPayout = 0
      this.subTotalWinlose = 0
      this.grandTotalTurnover = 0
      this.grandTotalValidTurnover = 0
      this.grandTotalPayout = 0
      this.grandTotalWinlose = 0
    }
  }
};
</script>